// extracted by mini-css-extract-plugin
export default {"pagination__items":"Pagination_pagination__items__lxHT-"};